import { AsyncStoreItem } from '@lib/store';
import { GetBoardingCertificateResponse } from 'src/sdk-servicing';

/**
 * GetBoardingCertificateResult model
 */
export interface GetBoardingCertificateResultModel {
  model: GetBoardingCertificateResponse | null;
}

/**
 * GetBoardingCertificateResponse model details
 */
export interface GetBoardingCertificateResultStateDetails extends AsyncStoreItem {}

/**
 * GetBoardingCertificateResult store state
 */
export interface GetBoardingCertificateResultState
  extends GetBoardingCertificateResultStateDetails,
    GetBoardingCertificateResultModel {}

/**
 * Name of the GetBoardingCertificateResult Store
 */
export const GET_BOARDING_CERTIFICATE_RESULT_STORE_NAME = 'getBoardingCertificateResult';

/**
 * GetBoardingCertificateResult Store Interface
 */
export interface GetBoardingCertificateResultStore {
  /** GetBoardingCertificateResult state */
  [GET_BOARDING_CERTIFICATE_RESULT_STORE_NAME]: GetBoardingCertificateResultState;
}
